import type { DeepRequired } from '../fixtures.types'

const getMiCaseList: DeepRequired<GetMiCaseListResponse> = {
  __typename: 'GetMiCaseListResponse',
  cases: [],
  filters: null,
  next_page: null,
  stats: {
    __typename: 'GetMiCaseListStats',
    count: 0,
    predicted_revenue: null,
  },
}

export default getMiCaseList
